import { MdDesktopWindows, MdPhoneIphone } from "react-icons/md";
import { ViewportMode } from "./types";

interface PreviewViewportToggleProps {
  mode: ViewportMode;
  onChange: (mode: ViewportMode) => void;
}

export const PreviewViewportToggle = ({ mode, onChange }: PreviewViewportToggleProps) => {
  const btn = (target: ViewportMode, Icon: typeof MdDesktopWindows, label: string) => (
    <button
      type="button"
      onClick={() => onChange(target)}
      className={`flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium transition-colors ${
        mode === target
          ? "bg-indigo-100 text-indigo-700 dark:bg-indigo-900/40 dark:text-indigo-300"
          : "text-slate-600 hover:bg-slate-100 dark:text-slate-400 dark:hover:bg-slate-700"
      }`}
    >
      <Icon size={16} />
      {label}
    </button>
  );

  return (
    <div className="inline-flex gap-1 rounded-lg border border-slate-200 p-1 dark:border-slate-700">
      {btn("desktop", MdDesktopWindows, "Desktop")}
      {btn("mobile", MdPhoneIphone, "Mobile")}
    </div>
  );
};
